/*
 * The Prompt Views english translation.
 */
export const PROMPT_VIEW_EN = {
  promptsViewHeading: 'Prompts',
  promptsViewDescription: 'Manage and configure your AI prompts',
  promptEditor: 'Prompt Editor',
  editAndManageYourCustomPrompt: 'Edit and manage your custom prompt',
  instructionLength: 'Instruction Length',
  instructions: 'Instructions',
  template: 'Template',
  scope: 'Scope',
  model: 'Model',
  temperature: 'Temperature',
  loadingPromptData: 'Loading prompt data',
  loadingPrompts: 'Loading prompts...',
  assistantPrefill: 'Chat Prefill',
  optional: 'Optional',
  addInstruction: 'Add Instruction',
  user: 'User',
  instruction: 'Instruction',
  enterInstructionTemplate: 'Enter instruction template',
  enterAssistantPrefillOptional: 'Enter chat prefill',
  file: 'File',
  featureActive: 'Feature active',
  activateFeature: 'Activate Feature',
  deactivateFeature: 'Deactivate Feature',
  yes: 'Yes',
  no: 'No',
  // PromptCreation.vue
  createNewPrompt: 'Create New Prompt',
  createNewPromptDescription:
    'Create a new prompt with multiple instructions and model configurations.',
  creating: 'Creating...',
  enterPromptName: 'Enter prompt name',
  fileBasedInstruction: 'File-based instruction',
  // PromptDataTable
  filterByName: 'Filter by name…',
  allModels: 'All Models',
  allScopes: 'All Scopes',
  usageWindowLabel: 'Usage window',
  usageWindowAll: 'All prompts',
  usageWindowLast24h: 'Last 24 hours',
  usageWindowLast7d: 'Last 7 days',
  usageWindowLast30d: 'Last 30 days',
  promptUsageColumn: 'Used ({window})',
  loadingPromptUsage: 'Loading prompt usage...',
  failedToLoadPromptUsage: 'Failed to load prompt usage',
  activeFilters: 'Active filters:',
  filterKeyName: 'Name',
  filterKeyModel: 'Model',
  filterKeyScope: 'Scope',
  filterKeyUsage: 'Usage',
  clearFilters: 'Clear filters',
  refresh: 'Refresh',
  showingResults: 'Showing {count} of {total} prompts',
  noPromptsFound: 'No prompts found',
  createFirstPrompt: 'Create your first prompt',
  dataRefreshed: 'Data refreshed',
  failedToLoadData: 'Failed to load data',
  // PromptColumns
  promptColumnName: 'Name',
  untitled: 'Untitled',
  noModel: 'No model',
  noScope: 'No scope',
  creator: 'Creator',
  unknownCreator: 'Unknown',
  // PromptEditor additional
  promptNotFound: 'Prompt not found',
  backToPrompts: 'Back to Prompts'
}
/*
 * The Prompt Views german translation.
 */
export const PROMPT_VIEW_DE = {
  promptsViewHeading: 'Prompts',
  promptsViewDescription: 'Verwalten und konfigurieren Sie Ihre KI-Prompts',
  promptEditor: 'Prompt Editor',
  editAndManageYourCustomPrompt: 'Bearbeiten und verwalten Sie Ihren individuellen Prompt',
  instructionLength: 'Anweisungslänge',
  instructions: 'Anweisungen',
  template: 'Vorlage',
  scope: 'Scope',
  model: 'Modell',
  temperature: 'Temperatur',
  loadingPromptData: 'Lade Prompt Daten',
  loadingPrompts: 'Lade Prompts...',
  assistantPrefill: 'Chat-Prefill',
  optional: 'Optional',
  addInstruction: 'Anweisung hinzufügen',
  user: 'Benutzer',
  instruction: 'Anweisung',
  enterInstructionTemplate: 'Anweisungstemplate eingeben',
  enterAssistantPrefillOptional: 'Chat-Prefill eingeben',
  file: 'Datei',
  featureActive: 'Feature aktiv',
  activateFeature: 'Feature aktivieren',
  deactivateFeature: 'Feature deaktivieren',
  yes: 'Ja',
  no: 'Nein',
  // PromptCreation.vue
  createNewPrompt: 'Neuen Prompt erstellen',
  createNewPromptDescription:
    'Erstellen Sie einen neuen Prompt mit mehreren Anweisungen und Modellkonfigurationen.',
  creating: 'Erstellt...',
  enterPromptName: 'Prompt Name eingeben',
  fileBasedInstruction: 'Dateibasierte Anweisung',
  // PromptDataTable
  filterByName: 'Nach Name filtern…',
  allModels: 'Alle Modelle',
  allScopes: 'Alle Scopes',
  usageWindowLabel: 'Nutzungszeitraum',
  usageWindowAll: 'Alle Prompts',
  usageWindowLast24h: 'Letzte 24 Stunden',
  usageWindowLast7d: 'Letzte 7 Tage',
  usageWindowLast30d: 'Letzte 30 Tage',
  promptUsageColumn: 'Verwendet ({window})',
  loadingPromptUsage: 'Prompt-Nutzung wird geladen...',
  failedToLoadPromptUsage: 'Prompt-Nutzung konnte nicht geladen werden',
  activeFilters: 'Aktive Filter:',
  filterKeyName: 'Name',
  filterKeyModel: 'Modell',
  filterKeyScope: 'Scope',
  filterKeyUsage: 'Nutzung',
  clearFilters: 'Filter zurücksetzen',
  refresh: 'Aktualisieren',
  showingResults: '{count} von {total} Prompts',
  noPromptsFound: 'Keine Prompts gefunden',
  createFirstPrompt: 'Erstellen Sie Ihren ersten Prompt',
  dataRefreshed: 'Daten aktualisiert',
  failedToLoadData: 'Fehler beim Laden der Daten',
  // PromptColumns
  promptColumnName: 'Name',
  untitled: 'Unbenannt',
  noModel: 'Kein Modell',
  noScope: 'Kein Scope',
  creator: 'Ersteller',
  unknownCreator: 'Unbekannt',
  // PromptEditor additional
  promptNotFound: 'Prompt nicht gefunden',
  backToPrompts: 'Zurück zu Prompts'
}
